import styled from "styled-components";

const GameCoverBox = styled.div`
  width: 40%;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

export default GameCoverBox;
